import { useCallback } from 'react';

import { Blend } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';

import { Badge } from '@/components/ui/badge';
import { Button } from '@/components/ui/button';
import { AuthenticatedRoutes } from '@/router/routes';

export const ConflictsState = () => {
  const { t } = useTranslation(['authenticated.settings']);
  const navigate = useNavigate();

  const handleResolve = useCallback(() => {
    navigate(AuthenticatedRoutes.DataReconciliation);
  }, [navigate]);

  return (
    <div className="flex items-start justify-between gap-4">
      <div className="flex flex-col gap-1">
        <div className="flex items-center gap-2">
          <h3 className="text-sm font-medium">
            {t('authenticated.settings:pages.integrations.refreshCard.conflicts.title')}
          </h3>
          <Badge variant="destructiveOutline" className="font-medium">
            {t('authenticated.settings:pages.integrations.refreshCard.conflicts.badge')}
          </Badge>
        </div>
        <p className="text-xs text-foreground">
          {t('authenticated.settings:pages.integrations.refreshCard.conflicts.subtitle')}
        </p>
      </div>
      <div className="flex shrink-0 items-center gap-2">
        <Button size="sm" variant="default" className="bg-chart-3" onClick={handleResolve}>
          <Blend />
          {t('authenticated.settings:pages.integrations.refreshCard.conflicts.action')}
        </Button>
      </div>
    </div>
  );
};
